class UpsellProducts extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".upsell-products__checkbox-input");
    this.variants = document.querySelectorAll("[data-upsell]");
    this.selectedProduct = this.dataset.variantId;
    this.descriptionNonChecked = this.querySelector(".upsell-products__non-checked");
    this.descriptionChecked = this.querySelector(".upsell-products__checked");
    this.priceElement = document.querySelector(".product-block--price .product__price");
    this.basePriceCents = null;
    this.originalPriceText = null;
  }

  connectedCallback() {
    if (this.priceElement) {
      this.originalPriceText = this.priceElement.textContent.trim();
      this.basePriceCents = this.parseDisplayedPrice(this.originalPriceText);
    }

    if (this.checkbox) {
      this.checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    }
    document.addEventListener("variant:change", this.handleVariantChange.bind(this));
    this.checkbox.disabled = false;
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener("change", this.handleCheckboxChange.bind(this));
    }
  }

  parseDisplayedPrice(text) {
    let cleaned = text.replace(/[^0-9.,]/g, "").trim();
    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");

    if (hasComma && hasDot) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else if (hasComma) {
      cleaned = cleaned.replace(",", ".");
    }

    return Math.round(parseFloat(cleaned) * 100);
  }

  detectCurrency(text) {
    if (text.includes("CHF")) return "CHF";
    if (text.includes("€")) return "€";
    if (text.includes("$")) return "$";
    return "€"; // Fallback
  }

  formatPrice(cents, currency) {
    const amount = cents / 100;
    if (currency === "CHF") {
      return "CHF " + amount.toFixed(2).replace(".", ".");
    }
    return amount.toFixed(2).replace(".", ",") + " " + currency;
  }

  handleVariantChange(changeEvent) {
    this.selectedProduct = changeEvent.detail.variant.id;
    this.removeUpsellFromCart();

    if (this.priceElement) {
      setTimeout(() => {
        this.originalPriceText = this.priceElement.textContent.trim();
        this.basePriceCents = this.parseDisplayedPrice(this.originalPriceText);
      }, 100);
    }

    const array_variants = Array.from(this.variants);
    if (array_variants.some((variant) => Number(variant.dataset.parentId) === Number(this.selectedProduct))) {
      this.setAvailableMessage();
    } else {
      this.setUnvailableMessage();
    }
  }

  setAvailableMessage() {
    this.classList.remove("unavailable");
  }

  setUnvailableMessage() {
    this.classList.add("unavailable");
  }

  handleCheckboxChange(event) {
    if (event.target.checked) {
      this.addUpsellToCart();

      if (this.priceElement && this.basePriceCents !== null) {
        this.variants.forEach((variant) => {
          if (Number(variant.dataset.parentId) === Number(this.selectedProduct) && variant.dataset.quantity) {
            console.log(variant.dataset.quantity);
            const currency = this.detectCurrency(this.originalPriceText);
            const totalCents = this.basePriceCents + Number(variant.dataset.price) * Number(variant.dataset.quantity);
            this.priceElement.textContent = this.formatPrice(totalCents, currency);
          }
        });
      }
    } else {
      this.removeUpsellFromCart();

      if (this.priceElement && this.originalPriceText) {
        this.priceElement.textContent = this.originalPriceText;
      }
    }
  }

  async addUpsellToCart() {
    this.variants.forEach((variant) => {
      if (Number(variant.dataset.parentId) === Number(this.selectedProduct)) {
        variant.selected = true;
        this.descriptionChecked.querySelector(".upsell-products__title").textContent = variant.dataset.productTitle;
        this.descriptionChecked.querySelector(".upsell-products__variant-title").textContent = variant.dataset.variantTitle;
        this.descriptionChecked.querySelector(".upsell-products__size-title").textContent = variant.dataset.sizeTitle;
      }
    });
    this.descriptionChecked.querySelector(".upsell-products__count").textContent =
      Array.from(this.variants).filter((variant) => Number(variant.dataset.parentId) === Number(this.selectedProduct)).length + "x";

    this.descriptionNonChecked.classList.add("hidden");
    this.descriptionChecked.classList.remove("hidden");
  }

  async removeUpsellFromCart() {
    this.checkbox.checked = false;
    this.variants.forEach((variant) => (variant.selected = false));
    this.descriptionNonChecked.classList.remove("hidden");
    this.descriptionChecked.classList.add("hidden");
  }
}

if (!customElements.get("upsell-products")) {
  customElements.define("upsell-products", UpsellProducts);
}

export default UpsellProducts;